<div class="container-resources-center">
  <div class="h3 main-title">{{ 'resourceCenter.title' | cxTranslate }}</div>

  <hr class="border border-primary" />

  <resource-center-content></resource-center-content>
</div>
